// React
import React, { Component } from 'react';

class SearchToggle extends Component {

  render() {
    const { searchType, help } = this.props;

    const tooltipTemplate = '<div class="tooltip search-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>';

    return (
      <div className="search-toggle">
          {searchType === 'products' &&
            <ul className="list-unstyled list-inline">
              <li className="list-inline-item active">{window.Drupal.t("Analysis")}</li>
              <li className="list-inline-item"><a href="/search/pages">{window.Drupal.t("Web Pages")}</a></li>
              <li className="list-inline-item d-inline-flex align-items-center" data-toggle="tooltip" data-template={tooltipTemplate} data-placement="bottom" data-html="true" title="" data-original-title={help} >
                <span>Help</span>
                <span className="search-help-icon fas fa-question" />
              </li>
            </ul>
          }
          {searchType === 'pages' &&
            <ul className="list-unstyled list-inline">
              <li className="list-inline-item"><a href="/search">{window.Drupal.t("Products")}</a></li>
              <li className="list-inline-item active">{window.Drupal.t("Web Pages")}</li>
            </ul>
          }
      </div>
    )
  }
}

export default SearchToggle;
